/**
 * Sorter
 * Example:
 * <div class="sorter" data-sorter-items=".my-class" data-sorter-default-order="asc">
		<div>
			<div class="sorter-header" data-sorter-item=".sorter-item-ordernr" data-sorter-item-type="number">Order no</div>
			<div class="sorter-header sorter-header-default" data-sorter-item=".sorter-item-date">Order date</div>
		</div>
		<ul>
			<li class="my-class">
				<div class="sorter-item-ordernr" data-sorter-value="1111">Order 1111</div>
				<div class="sorter-item-date" data-sorter-value="2013-01-01">2013-01-01</div>
			</li>
			<li class="my-class">
				<div class="sorter-item-ordernr" data-sorter-value="3333">Order 3333</div>
				<div class="sorter-item-date" data-sorter-value="2014-01-01">2014-01-01</div>
			</li>
			<li class="my-class">
				<div class="sorter-item-ordernr" data-sorter-value="2222">Order 2222</div>
				<div class="sorter-item-date" data-sorter-value="2011-01-01">2011-01-01</div>
			</li>
		</ul>
	</div>
 */

(function($) {
    'use strict';

    var Sorter = function(el) {
        this.$el = $(el);
        this.$items = this.$el.find(this.$el.attr('data-sorter-items'));
        this.defaultOrder = this.$el.attr('data-sorter-default-order') || 'asc';
        this.$defaultItem = this.$el.find('.sorter-header-default');

        this.init();
    };

    Sorter.prototype = {
        init: function() {
            var that = this;

            // Handle default item - Set css class and order
            if (typeof this.$defaultItem !== 'undefined') {
                that.setHeader(this.$defaultItem);
                that.handleSort(this.$defaultItem);
            }

            that.bindEvents();
        },

        bindEvents: function() {
            var that = this;

            this.$el.on('click', '.sorter-header', function() {
                that.setHeader($(this));
                that.handleSort($(this));
            });
        },

        setHeader: function($this) {
            var that = this;

            if ($this.hasClass('sorter-asc')) {
                that.$el.find('.sorter-header').removeClass('sorter-asc sorter-desc');
                $this.addClass('sorter-desc');
            } else {
                that.$el.find('.sorter-header').removeClass('sorter-asc sorter-desc');
                $this.addClass('sorter-asc');
            }
        },

        handleSort: function($this) {
            var that = this,
                sortEl = $this.attr('data-sorter-item'),
                orderAsc = $this.hasClass('sorter-asc'),
                isNumber = $this.attr('data-sorter-item-type') === 'number';

            that.$items.sort(function(a, b) {
                // eslint-disable-line id-length
                var objects;
                if (orderAsc) {
                    if (isNumber) {
                        objects =
                            parseInt($(a).find(sortEl).attr('data-sorter-value'), 10) <
                            parseInt($(b).find(sortEl).attr('data-sorter-value'), 10)
                                ? 1
                                : -1;
                    } else {
                        objects =
                            $(a).find(sortEl).attr('data-sorter-value') <
                            $(b).find(sortEl).attr('data-sorter-value')
                                ? 1
                                : -1;
                    }
                } else if (isNumber) {
                    objects =
                        parseInt($(a).find(sortEl).attr('data-sorter-value'), 10) >
                        parseInt($(b).find(sortEl).attr('data-sorter-value'), 10)
                            ? 1
                            : -1;
                } else {
                    objects =
                        $(a).find(sortEl).attr('data-sorter-value') >
                        $(b).find(sortEl).attr('data-sorter-value')
                            ? 1
                            : -1;
                }

                return objects;
            });

            $(that.$items[0]).parent().html(that.$items);
        }
    };

    $.fn.sorter = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('sorter');

            if (!data) {
                $this.data('sorter', (data = new Sorter(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };

    $.fn.sorter.Constructor = Sorter;
})(jQuery);
